import React from 'react';
import { Modal, ModalFooter } from '@/components/common';
import { DeviceDTO } from '@/models';

interface DeviceDeleteModalProps {
  isOpen: boolean;
  device: DeviceDTO | null;
  isSaving: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

export const DeviceDeleteModal: React.FC<DeviceDeleteModalProps> = ({
  isOpen,
  device,
  isSaving,
  onConfirm,
  onClose,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      closeOnBackdropClick={false}
      title="Delete Device"
      footer={
        <ModalFooter
          onCancel={onClose}
          onConfirm={onConfirm}
          confirmText="Delete"
          confirmVariant="danger"
          isLoading={isSaving}
        />
      }
    >
      <p>
        Are you sure you want to delete device{' '}
        <strong>{device?.serialNumber || device?.identifier}</strong>? This action cannot be undone.
      </p>
    </Modal>
  );
};
